import api from "@/axiosInstance.js";
import type { ApiRequestOptions, User } from "@/types/app";

export const getAllUsers = async (
  user: User | null | undefined,
  { signal }: ApiRequestOptions = {},
) => {
  try {
    if (!user?.permissions?.includes("see_users")) {
      throw new Error("Permission denied: see_users required");
    }
    const res = await api.get(`/user/user/all`, { withCredentials: true, signal });
    return res.data.data ?? [];
  } catch {
    // console.log(`getAllUsers error: ${error}`);
    return [];
  }
};

export const getAllPermissions = async ({ signal }: ApiRequestOptions = {}) => {
  try {
    const res = await api.get(`/user/user/permissions/all`, { withCredentials: true, signal });
    return res.data.data;
  } catch {
    // console.log(`getAllPermissions error: ${error}`);
    return [];
  }
}
export const getUserPermissions = async (userId: string | number) => {
  try {
    const res = await api.get(`/user/user/permissions/${userId}`, { withCredentials: true });
    return res.data.data;
  } catch {
    // console.log(`getUserPermissions error: ${error}`);
    return [];
  }
}
